import type { FC } from "react";
import Icon from "../../../Icon";
import type { IconType } from "../../../Icon/Icon";
import Link from "../../../Link";
import * as s from "./InformationSlide.module.scss";

type InformationSlideProps = {
	icon: string;
	text: string;
	href?: string;
};

const InformationSlide: FC<InformationSlideProps> = ({ icon, text, href }) => {
	return (
		<>
			{href ? (
				<Link className={s.slide} href={href}>
					<span className={s.info}>
						<Icon icon={icon as IconType} className={s.icon} />
						<p className={s.infoText}>{text}</p>
					</span>
				</Link>
			) : (
				<div className={s.slide}>
					<span className={s.info}>
						<Icon icon={icon as IconType} className={s.icon} />
						<p className={s.infoText}>{text}</p>
					</span>
				</div>
			)}
		</>
	);
};

export default InformationSlide;
